import React, { FC, useState } from 'react';
import styles from './NewOrderDetailsHistory.module.scss';
import { WhiteBlock } from 'components/WhiteBlock';
import { Title } from 'components/Title';
import { BlockResize } from 'components/BlockResize';
import { InformationOrderBlock } from 'components/InformationOrderBlock';
import { EmployedsSearchBlock } from 'components/EmployedsSearchBlock';
import { InfoEmployedItem } from 'components/InfoEmployedItem';
import { Button } from 'ui/Button';
import { ModalPayments } from 'components/ModalPayments';
import { SuccessErrorInfo } from 'components/SuccessErrorInfo';
import { BeneficiarBlock } from 'components/BeneficiarBlock';

interface BeneficiaryTypes {
  id: number;
  is_active: boolean;
  is_added_to_ms: boolean;
  is_oferta_uploaded: boolean;
  tochka_uuid: string;
  created_at: string;
  updated_at: string;
}

interface NewOrderDetailsHistoryTypes {
  status?: any;
  payment?: any;
  objPayment?: any;
  data?: any;
  role?: string;
  actionWithOrder?: ((str: string) => void) | any;
  id?: string | number;
  isCanceled?: boolean;
  create?: boolean;
  beneficiary?: BeneficiaryTypes;
}

export const NewOrderDetailsHistory: FC<NewOrderDetailsHistoryTypes> = ({
  status = '',
  payment,
  objPayment = {},
  data,
  role,
  id,
  isCanceled,
  create = false,
  actionWithOrder,
  beneficiary,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationText, setNotificationText] = useState('');

  const handleSuccess = (message?: string) => {
    setNotificationText(message || 'Операция выполнена успешно');
    setShowNotification(true);
  };

  const handleDelete = () => {
    if (!create) {
      actionWithOrder(`${id}/reject-worker`);
    }
  };
  return (
    <>
      <div>
        <WhiteBlock className={styles.statusBlock}>
          <div className={styles.container_title}>
            <Title title='Статус' />
            <Button theme='filed' size='S' onClick={() => setOpenModal(true)}>
              Отправить выплату
            </Button>
          </div>
          {/* <div className={styles.blockChoose}></div> */}
          {status && <Title className={styles.text} title={status.text} />}
        </WhiteBlock>
      </div>

      {(data?.is_ready || create) &&
        (!data?.worker || data?.is_draft ? (
          <EmployedsSearchBlock
            workSupport={role !== 'worksupport'}
            isReady={data?.is_ready}
            worker={data?.worker ? [data.worker] : []}
          />
        ) : (
          <WhiteBlock>
            <div className={styles.title}>
              <Title title='Исполнитель' />
              {data?.worker?.is_deleted && <p>Профиль удален</p>}
            </div>
            <div className={styles.blockChoose}>
              <InfoEmployedItem
                phone={data?.worker?.phone}
                workSupport={role !== 'worksupport'}
                fns_status={data?.worker?.fns_status}
                fio={`${data?.worker?.surname} ${data?.worker?.name} ${
                  data?.worker?.patronymic || ''
                }`}
                inn={data?.worker?.inn}
                workerAppStatus={data?.worker?.app_status}
                deleteEmployedHandler={create ? undefined : handleDelete}
                isDelete={isCanceled || data?.status?.value === 'worker_took_order'}
                worker_id={data?.worker?.id}
                worker_app_id={data?.worker?.worker_app_id}
              />
            </div>
          </WhiteBlock>
        ))}
      <BeneficiarBlock data={beneficiary} />
      {payment && (
        <BlockResize
          error={payment?.failure_description || !payment?.success}
          style={{ width: '100%' }}
          title='Выплата'
          // open='Выплата'
          notUse>
          <InformationOrderBlock payment objectInfo={objPayment} />
        </BlockResize>
      )}
      {openModal && (
        <ModalPayments
          isShowPaymentsModal={openModal}
          setIsShowPaymentsModal={setOpenModal}
          orderId={String(id)}
          handleSuccess={handleSuccess}
        />
      )}
      {showNotification && (
        <SuccessErrorInfo
          type='success'
          text={notificationText}
          handleClose={() => setShowNotification(false)}
        />
      )}
    </>
  );
};
